<template>
    <OptionsPanel
        ref="optionspanel"
        :tabs="tabs" 
        :saving="saving" 
        :initial-tab="initialTab"
        :initial-data="initialData"
        @settings-change="settingsChangeHandler"  />
</template>

<script>
// import eventBus from '@/utils/event-bus';
import { setPermanentData } from '@/utils/browser-storage';
import { mapGetters } from 'vuex';
import { updateQueryParams } from '@/utils/url-utils'

export default {
    components: {
        OptionsPanel: () => import(/* webpackChunkName: "OptionsPanel" */ '@/components/OptionsPanel.vue'),
    },
    data() {
        return {
            saving: false, 
            data: {},
            initialData: {},
            popupInitialized: false,
            tabs: [
                {
                    label: 'Favoriten',
                    id: 'favourites',
                    component: 'POISettingsFavourites',
                },
                {
                    label: 'Verkehr',
                    id: 'traffic',
                    component: 'POISettingsTraffic'
                },
                {
                    label: 'Tanken',
                    id: 'gasStations',
                    component: 'POISettingsGasStations',
                },
                {
                    label: 'Laden',
                    id: 'chargingStations',
                    component: 'POISettingsChargingStations',
                },
                // {
                //     label: 'Umweltzonen',
                //     id: 'umweltzonen'
                // },
                {
                    label: 'Parken',
                    id: 'carParks',
                    component: 'POISettingsCarParks',
                },
                {
                    label: 'Haltestellen',
                    id: 'nearbyStations',
                    component: 'POISettingsNearbyStations',
                },
                {
                    label: 'Reise-Radar',
                    id: 'travelRadar',
                    component: 'POISettingsTravelRadar',
                },
                {
                    label: 'Sehenswertes',
                    id: 'sights',
                    component: 'POISettingsSights',
                },
                {
                    label: 'ÖAMTC Standorte',
                    id: 'oeamtcLocations',
                    component: 'POISettingsOeamtcLocations',
                },
                {
                    label: 'Vorteilspartner',
                    id: 'partners',
                    component: 'POISettingsPartners',
                },
                {
                    label: 'Raststätten',
                    id: 'roadHouses',
                    component: 'POISettingsRoadHouses',
                },
                {
                    label: 'Mautstraßen',
                    id: 'tollRoads',
                    component: 'POISettingsTollRoads',
                },
                {
                    label: 'Berg- und Passstraßen',
                    id: 'passRoads',
                    component: 'POISettingsPassRoads',
                },
                {
                    label: 'Camping',
                    id: 'camping',
                    component: 'POISettingsCamping',
                },
                // {
                //     label: 'Roller',
                //     id: 'roller'
                // },
                // {
                //     label: 'Fahrräder',
                //     id: 'fahrraeder'
                // },
                // {
                //     label: 'Behörden',
                //     id: 'behoerden'
                // },
                // {
                //     label: 'Gesundheit',
                //     id: 'gesundheit'
                // },
                // {
                //     label: 'Wetter',
                //     id: 'wetter'
                // },
            ],
        }
    },
    computed: {
        ...mapGetters(['poiSettings', 'selectedPOIs']),
        initialTab() {
            if(this.selectedPOIs.length === 1 && this.selectedPOIs[0] !== 'greenzone') {
                return this.selectedPOIs[0];
            } else {
                return this.tabs[0].id;
            }
        }
    },
    mounted() {
        this.setInitialData()
    },
    methods: {
        triggerSave() {
            this.optionsPanelSaveHandler()
        },
        settingsChangeHandler({data, id}) {
            this.data[id] = data;
        },
        optionsPanelSaveHandler() {
            this.saving = true;
            this.$emit('saving', this.saving);
            this.$store.commit('setPoiSettings', this.data);
            // only use settings from url query once and remove when manually saving settings
            this.$store.commit('setQueryPoiSettings', false)
            updateQueryParams(this.$route, { poiOptions: this.data })
            setPermanentData('poi-settings', this.data);
            setTimeout(() => {
                this.saving = false;
                this.$emit('saving', this.saving);
                this.$store.dispatch('loadPOIResults');
            }, 300);
        },
        setInitialData() {
            // deep clone the values from the store to be used as a starting point for changes
            this.initialData = JSON.parse(JSON.stringify(this.poiSettings));
            this.data = this.initialData;
        },
        updateView() {
            this.$refs['optionspanel'].initPanelView()
        }
    }
}
</script>

<style lang="scss">
</style>
